import { isEmpty, isPlainObject, uniq } from 'lodash';

export const isMobile = ((): boolean => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();

// This function ensures that the user has granted the browser permission to use audio and video
// devices. If permission has not been granted, it will cause the browser to ask for permission
// for audio and video at the same time (as opposed to separate requests).
export async function ensureMediaPermissions(): Promise<void> {
  return navigator.mediaDevices
    .enumerateDevices()
    .then((devices) => devices.every((device) => !(device.deviceId && device.label)))
    .then((shouldAskForMediaPermissions) => {
      if (shouldAskForMediaPermissions) {
        return navigator.mediaDevices
          .getUserMedia({ audio: true, video: true })
          .then((mediaStream) => mediaStream.getTracks().forEach((track) => track.stop()));
      }
    });
}

// Recursively removes any object keys with a value of undefined
export function removeUndefineds<T>(obj: T): T {
  if (!isPlainObject(obj)) {return obj;}

  const target: { [name: string]: any } = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const val = obj[key];
      if (typeof val !== 'undefined') {
        target[key] = removeUndefineds(val);
      }
    }
  }

  return target as T;
}

export function setOnlineUser(connectionId: string, isOnline: boolean): void {
  let onlineUserArray = [];
  const store = localStorage.getItem('_online_');
  if (isEmpty(store))
  {onlineUserArray = [];}
  else
  {onlineUserArray = store.split(',');}
  const index = onlineUserArray.indexOf(connectionId);
  if (isOnline && index < 0) {
    onlineUserArray.push(connectionId);
  } else if (!isOnline && index >= 0) {
    onlineUserArray.splice(index, 1);
  }

  onlineUserArray = uniq(onlineUserArray);
  localStorage.setItem('_online_', onlineUserArray.join(','));
}
export function resetNotificationDot(): void {
  const spanNotification = document.getElementById('notificationBadge');
  const notificationTextBold = document.getElementById('notificationTextBold');
  if (spanNotification) {
    spanNotification.style.display = 'none';
    spanNotification.classList.add('d-none');
  }
  if (notificationTextBold) {
    notificationTextBold.classList.remove('fw-bold');
  }
}

export function displayNotificationDot(): void {
  const spanNotification = document.getElementById('notificationBadge');
  const notificationTextBold = document.getElementById('notificationTextBold');
  if (spanNotification) {
    spanNotification.style.display = 'block';
    spanNotification.classList.remove('d-none');
  }
  if (notificationTextBold) {
    notificationTextBold.classList.add('fw-bold');
  }
}

export function showUpgradeModel(isShow: boolean, title='', body=''): void {
  if (isShow) {
    document.getElementById('upgradeNotificationTitle').innerHTML = title;
    document.getElementById('upgradeNotificationBody').innerHTML = body;
    document.querySelector('.modal').classList.add('show');
    document.getElementById('upgradeModal').style.display = 'block';
  } else {
    document.getElementById('upgradeNotificationTitle').innerHTML = '';
    document.getElementById('upgradeNotificationBody').innerHTML = '';
    document.querySelector('.modal').classList.remove('show');
    document.getElementById('upgradeModal').style.display = 'none';
  }
}
